module.exports = __webpack_public_path__ + "img/features-img1.a8b8e9f8.png";